import { render, staticRenderFns } from "./not-accessible.vue?vue&type=template&id=0d591303&scoped=true&"
import script from "./not-accessible.vue?vue&type=script&lang=js&"
export * from "./not-accessible.vue?vue&type=script&lang=js&"
import style0 from "./not-accessible.vue?vue&type=style&index=0&id=0d591303&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d591303",
  null
  
)

export default component.exports